import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

const Textarea = ({ ...args }) => {
  return <TextareaAutosize {...args} />;
};

export default Textarea;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Textarea/Textarea.js